import api from "./api";

class ProfileService {
    getMe() {
        return api.get("/api/profiles/me/");
    }

    updateMe(data) {
        return api.patch("/api/profiles/me/", data);
    }

    uploadProfileImage(blob) {
        const formData = new FormData();
        formData.append("profile_image", blob, "profile.jpg");
        return api.patch("/api/profiles/me/image/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    deleteProfileImage() {
        return api.delete("/api/profiles/me/image/delete/");
    }

    changePassword(current_password, new_password) {
        return api.post("/api/profiles/me/change-password/", {
            current_password,
            new_password,
        });
    }
}

export default new ProfileService();
